import { render } from "./IgnoredEmailList.vue?vue&type=template&id=5ed89230&ts=true"
import script from "./IgnoredEmailList.vue?vue&type=script&lang=ts"
export * from "./IgnoredEmailList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__